import React from 'react';
import { useDidMount, useTranslation } from '@bcp-channels-sharedcomponents-reactjs/core/dist/hooks';
import { ComponentInfo, PdfViewerDrawer } from '@components';
import { avatarLogoBcp } from '@icons';
import { useDrawer, useFetchDocument } from '@hooks';
import { Box, SignDocCard } from '@bcp-nextgen-dx-component-factory/accolade-design-system';
import {
	SignDocCardSignedMode,
	SignDocCardUnsignedMode,
} from '@bcp-nextgen-dx-component-factory/accolade-design-system/dist/organisms/SignDocCard/SignDocCard.models';
import { rem } from '@helpers';
import { useBankTerms, useNavigationStore, useSelectedSolution, useServiceResponse } from '@store';
import { PromoCodeStatus } from '@api/izibizi-xp';

export const BankDocumentPlaceholder: React.FC = () => {
	const t = useTranslation();
	const bankTermsDrawerName = 'bankTerms';
	const { show: showPdfDrawer, hide: hidePdfDrawer } = useDrawer(bankTermsDrawerName);
	const { acceptTerms, termsWereAccepted } = useBankTerms();
	const { flow } = useNavigationStore();
	const solutionSelected = useSelectedSolution();
	const { retrievePromoCodeDetail } = useServiceResponse();

	const defineDocumentAccordingPromotion = () => {
		let documentValue: string;
		const codeStatus = retrievePromoCodeDetail?.promoCodeStatus;
		const isSubCodeValid = codeStatus === PromoCodeStatus.ACTIVE ? true : false;

		if (isSubCodeValid) {
			return (documentValue = t('document.conditionsTermsBankWithPromotion.id'));
		} else return (documentValue = t('document.conditionsTermsBank.id'));
	};
	const { base64BankDocument: base64Terms, fetchBankDocument } = useFetchDocument({
		reference: defineDocumentAccordingPromotion(),
	});

	const generalConditionsSolutionName = t('placeholders.enterpriseSolution.generalConditions.title', {
		planName: solutionSelected?.name,
	});

	let descriptionSignDocCard = t('placeholders.millennium.documentContract');
	let titleDoc = t('placeholders.millenniumDocument.terms.title');

	if (flow === 'integratedSolution') {
		descriptionSignDocCard = generalConditionsSolutionName;
		titleDoc = generalConditionsSolutionName;
	}

	const handleOnClickReadAndAcceptDocument = () => {
		showPdfDrawer();
	};

	const handleOnClickAcceptTerms = () => {
		acceptTerms();
		hidePdfDrawer();
	};

	const signedProps: SignDocCardSignedMode = {
		mode: 'signed',
		linkProps: {
			middleContent: t('general.document.actions.consult'),
			onPress: handleOnClickReadAndAcceptDocument,
		},
	};

	const unsignedProps: SignDocCardUnsignedMode = {
		mode: 'unsigned',
		buttonProps: {
			label: t('general.document.actions.readAndAccept'),
			onPress: handleOnClickReadAndAcceptDocument,
		},
		image: {
			type: 'avatar',
			avatarProps: {
				source: avatarLogoBcp,
				backgroundColor: 'transparent',
			},
		},
	};

	useDidMount(() => {
		fetchBankDocument();
	});

	return (
		<ComponentInfo name="BankDocumentPlaceholder">
			<Box styles={{ marginTop: rem(20) }}>
				<SignDocCard
					{...(termsWereAccepted ? signedProps : unsignedProps)}
					title={t('general.brands.millennium')}
					description={descriptionSignDocCard}
				/>
				{base64Terms && (
					<PdfViewerDrawer
						title={titleDoc}
						subtitle={t('general.pdfViewer.attentionRead')}
						base64={base64Terms}
						drawerUniqueName={bankTermsDrawerName}
						handleOnClickAcceptTerms={handleOnClickAcceptTerms}
						wasAccepted={termsWereAccepted}
					/>
				)}
			</Box>
		</ComponentInfo>
	);
};
